export function Spinner({ className = "h-6 w-6" }: { className?: string }) {
  return (
    <svg
      className={`animate-spin text-brand-500 ${className}`}
      viewBox="0 0 24 24"
      fill="none"
      role="status"
      aria-label="Chargement"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}

export function LoadingSection({
  label = "Chargement…",
  className = "",
}: {
  label?: string;
  className?: string;
}) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 py-16 text-ink-500 ${className}`}>
      <Spinner />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function LoadingInline({ label = "Chargement…" }: { label?: string }) {
  return (
    <div className="flex items-center gap-2 text-sm text-ink-500">
      <Spinner className="h-4 w-4" />
      <span>{label}</span>
    </div>
  );
}
